<template>
  <div id="homeTitle">
    <div class="t">T</div>
    <div class="content">
      <p>{{ this.content.Chinese }}</p>
      <p>{{ this.content.English }}</p>
    </div>
    <div class="line"></div>
  </div>
</template>

<script>
export default {
  name: "HomeTitle",
  props: {
    content: Object
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/global";
#homeTitle {
  width: 75%;
  margin: 0 auto;
  display: flex;
  position: relative;
  .t {
    font-size: 50px;
    font-weight: 800;
    color: #3490ec;
  }
  .content {
    color: #3490ec;
    font-weight: 500;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    text-align: left;
    p:nth-child(2) {
      margin-bottom: 5px;
    }
  }
  .line {
    width: 85%;
    height: 100%;
    border-bottom: 1px solid #479aed;
    position: absolute;
    left: 150px;
    bottom: 11%;
  }
}
</style>
